// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-O":"O_cost-saving-O__b_JiV"};